<template>
    <div class="filter-item">
        <filter-item-menu v-model="activeItem" :readonly="!isEditMode"></filter-item-menu>
        <div class="filter-right" v-if="isEditMode">
            <div class="formItem"> <!-- oder filter-placeholder -->
                <component
                        only-field
                        :block-type-name="getFieldOptions.blockTypeName"
                        :default="getFieldOptions.default"
                        :instructions="getFieldOptions.instructions"
                        :field-layout-id="getFieldOptions.fieldLayoutId"
                        :fields="getFieldOptions.fields"
                        :is="getFieldComponent(getFieldOptions)"
                        :label="getFieldOptions.label"
                        :limit="getFieldOptions.limit"
                        :items="getFieldOptions.options"
                        :restrictedFiles="getFieldOptions.restrictedFiles"
                        :suffix="getFieldOptions.suffix"
                        v-model="getFieldValue"
                ></component>
            </div>
            <button class="btn-filter-go icon-arrow-right" @click="switchMode"></button>
        </div>
        <div class="filter-right" v-else>
            <div class="filter-placeholder">
                {{ getFieldLabel }}
                <div class="filter-options">
                    <button class="btn-icon-only icon-trash-small" @click="remove"></button>
                    <button class="btn-icon-only icon-edit" @click="switchMode"></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import FilterItemMenu from '@/components/filter/FilterItemMenu'
  import _ from 'lodash'

  export default {
    components: { FilterItemMenu },
    props: {
      value: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        isEditMode: true
      }
    },
    mounted () {
      if (typeof this.value.item !== 'undefined') {
        this.isEditMode = this.value.editMode
      }
    },
    methods: {
      switchMode () {
        this.isEditMode = !this.isEditMode
        this.$emit('input', {
          item: this.activeItem.item,
          path: this.activeItem.path,
          type: this.getFieldOptions.type,
          value: this.activeItem.value,
          label: this.getFieldLabel,
          editMode: this.isEditMode
        })
      },
      remove () {
        this.$emit('input', {})
      }
    },
    computed: {
      getFieldComponent () {
        return (settings) => {
          switch (settings.type) {
            case 'craft\\fields\\Assets':
              if (settings.allowedKinds && settings.allowedKinds.indexOf('image') > -1 && settings.allowedKinds.length === 1) {
                if (settings.limit === '1') {
                  return 'image-upload'
                }

                return 'gallery-input'
              }

              return 'file-upload'
            case 'craft\\fields\\PlainText':
              if (settings.multiline) {
                // in der suche machen wir keine textarea
                // return 'text-area'
              }
              return 'text-field'
            case 'craft\\fields\\Categories':
            case 'modules\\raumkarte\\fields\\Categories':
            case 'craft\\fields\\Dropdown':
              return 'dropdown'
            case 'craft\\fields\\Number':
              return 'number-range'
            case 'craft\\fields\\Matrix':
              return 'matrix'
            case 'craft\\fields\\Lightswitch':
              return 'lightswitch'
            case 'craft\\fields\\Date':
              return 'date'
          }
        }
      },
      getFieldOptions () {
        let allOptions = this.$store.getters['search/getSearchOptions']
        let path = this.activeItem.path.split(';')
        let result = null

        for (let i = 0; i < path.length; i++) {
          result = _.filter(allOptions, (field) => field.handle == path[i])
          if (result.length === 1) {
            result = result[0]
            if (typeof result.fields !== 'undefined') {
              allOptions = result.fields
            } else {
              break
            }
          }
        }

        return result
      },
      getFieldLabel () {
        switch (this.getFieldOptions.type) {
          case 'craft\\fields\\Assets':
            return false
          case 'craft\\fields\\Categories':
          case 'modules\\raumkarte\\fields\\Categories':
          case 'craft\\fields\\Dropdown':
            if (this.activeItem.value instanceof Array) {
              // z.b. multiselect
              let result = ''
              for (let i = 0; i < this.activeItem.value.length; i++) {
                let temp = this.getFieldOptions.options.filter((option) => option.value === this.activeItem.value[i])
                if (temp.length > 0) {
                  if (i > 0) result += ', '
                  result += temp[0].label
                }
              }

              return result
            }

            // einfaches select
            let result = this.getFieldOptions.options.filter((option) => option.value === this.activeItem.value)
            if (result.length > 0) {
              return result[0].label
            }

            return result
          case 'craft\\fields\\Matrix':
            return 'matrix'
          case 'craft\\fields\\Lightswitch':
            if (this.activeItem.value === true) {
              return 'Ja'
            }

            return 'Nein'
          case 'craft\\fields\\Number':
            if (typeof this.activeItem.value === 'object' && this.activeItem.value !== null) {
              return this.activeItem.value.from + ' bis ' + this.activeItem.value.to + ' ' + this.getFieldOptions.suffix
            }

            return this.activeItem.value + ' ' + this.getFieldOptions.suffix
          case 'craft\\fields\\Date':
          case 'craft\\fields\\PlainText':
          default:
            return this.activeItem.value
        }
      },
      getFieldValue: {
        get () {
          return this.activeItem.value ? this.activeItem.value : null
        },
        set (newValue) {
          this.$emit('input', {
            item: this.activeItem.item,
            path: this.activeItem.path,
            type: this.getFieldOptions.type,
            value: newValue,
            label: this.getFieldLabel,
            editMode: this.isEditMode
          })
        }
      },
      activeItem: {
        get () {
          return this.value
        },
        set (newValue) {
          this.$emit('input', {
            item: newValue.item,
            path: newValue.path,
            type: newValue.type,
            value: null,
            label: null,
            editMode: this.isEditMode
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>
